

import team_image_1 from '@/images/gallery/team_image_1.jpg'

export default {
  "header": {
    "support": "Supportez-nous",
    "phone": "(+228) 79569276 / 90858351",
    "email": "Email: associationdaideauxhandicapesh@gmail.com / aplahaplah02@gmail.com",
    "language": "Langue",
    "languages": {
      "arabic": "Arabe",
      "french": "Français",
      "english": "Anglais"
    },
    "menu": {
      "home": "Accueil",
      "objectives": "Objectifs",
      "about": "À propos",
      "leaders": "Dirigeant",
      "gallery": "Galerie",
      "contact": "Contact"
    },
    "donate": "Faire un don"
  },
  "banner": {
    "title1": "Unissons-nous",
    "title2": "pour soutenir ceux qui en ont besoin",
    "title3": "Construisons un monde inclusif,",
    "title4": "un pas à la fois"
  },
  "about": {
    "title": "À propos de l'Association d'Aide aux personnes en difficulté Musulmans",
    "description": "L'Association pour l'Aide aux Handicapés Musulmans (AS.A.HA.M) est une organisation non gouvernementale fondée par des musulmans et de jeunes engagés dans la région des Plateaux, en République du Togo. Elle œuvre pour la reconnaissance de la dignité humaine et met en place des actions concrètes afin de répondre aux besoins spécifiques des communautés, en particulier ceux des personnes en difficulté.",
    "origin": {
      "title": "Origine et Fondation",
      "items": [
        "Créée dans un esprit de solidarité islamique et humanitaire.",
        "Fondée avec pour objectif principal de répondre aux défis rencontrés par les personnes en difficulté",
        "Destinée à être progressivement déployée à l'échelle nationale et régionale, notamment en Afrique de l'Ouest."
      ]
    },
    "mission": {
      "title": "Mission et Valeurs",
      "items": [
        "Mission principale : Améliorer la qualité de vie des personnes en difficulté tout en soutenant leur inclusion sociale et économique.",
        "Valeurs fondamentales : Respect de la dignité humaine, solidarité communautaire et responsabilité patriotique."
      ]
    },
    "vision": {
      "title": "Vision des Initiateurs",
      "items": [
        "Travailler dans un esprit de service commun au sein de la société islamique et patriotique.",
        "Faire preuve d'engagement envers les devoirs religieux, sociaux et humains dans leurs activités."
      ]
    }
  },
  "objectives": {
    "title": "Objectifs",
    "items": [
      {
        "title": "Centres d'éducation",
        "description": "Mettre en place des centres éducatifs accessibles à toutes les générations."
      },
      {
        "title": "Accès à l'eau potable",
        "description": "Construire des puits et des forages dans les zones rurales et urbaines pour améliorer le développement social et humain."
      },
      {
        "title": "Promotion des langues universelles",
        "description": "Encourager l'apprentissage des langues arabe, française et anglaise pour une meilleure intégration et communication à l'échelle mondiale."
      },
      {
        "title": "Formation et autonomisation",
        "description": "Organiser des séminaires et des travaux pratiques pour encourager le développement autonome dans les secteurs publics et privés."
      },
      {
        "title": "Renforcement des relations fraternelles",
        "description": "Favoriser la collaboration entre associations islamiques et non islamiques pour des objectifs communs, notamment la promotion de la culture islamique."
      }
    ]
  },
  "achievements": {
    "title": "Nos réalisations"
  },
  "gallery": {
    "title1": "Images Gallery AS.A.HA.M",
    "title2": "Images Partenariat AS.A.HA.M & Matw Project",
    "filters": {
      "all": "Tout",
      "medical": "Mosquées",
      "mosque": "Mosquées",
      "shelter": "Forages",
      "water": "Forages",
      "donation": "Dons",
      "well": "Puits"
    }
  },
  "leaders": {
    "title": "Les Dirigeants",
    "members": [
      {
        "name": "ALI Tairou Abd Haddi",
        "position": "Président",
        "photo":team_image_1
      },
      {
        "name": "IDRISSOU Abdourachid",
        "position": "Sécrétaire Général",
        "photo":team_image_1
      },
      {
        "name": "TCHA KOURA Zouberou",
        "position": "Délégué Chargé des Projets",
        "photo":team_image_1
      },
      {
        "name": "DJIBRILA SOUMAYATOU",
        "position": "Comptable",
        "photo":team_image_1
      }
    ]
  },
  "contact": {
    "title": "Contactez-nous",
    "subtitle": "Travailler Ensemble Pour Faire La Différence",
    "form": {
      "name": "Votre Nom",
      "email": "Email",
      "phone": "Téléphone",
      "help": "Comment pouvons-nous vous aider?",
      "message": "Message",
      "submit": "Envoyer le message"
    },
    "address": "BP: 361 kpalimé Togo",
    "phone": "Téléphone (+228) 79569276 / 90858351",
    "email": "associationdaideauxhandicapesh@gmail.com"
  },
  "footer": {
    "newsletter": {
      "title": "Abonnez-vous à notre newsletter pour les mises à jour",
      "placeholder": "Entrez votre email",
      "button":"Envoyer"
    },
    "copyright": "Copyrights (c) 2024 AS.A.HA.M. Tous droits réservés."
  }
}
